function ContactManager() {

    /// <summary>
    /// This object provides client-side functions for the Widget.Project.ContacManager visual. <br/>
    /// <br/>
    /// Author: MWI<br />
    /// Date: 12.05.2016<br />
    /// Copyright ©: EUDT GmbH 2016 <br />
    /// Version-History:<br />
    /// *** v1.0.2 - 23.03.2017                                               *<br />
    /// **********************************************************************<br />
    /// * - added reload of form after save                                   *<br />
    /// **********************************************************************<br />
    /// *** v1.0.1 - 06.06.2016                                               *<br />
    /// **********************************************************************<br />
    /// * - added support for more buttons                                   *<br />
    /// * - documentation                                                     *<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 12.05.2016                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>

}
ContactManager.prototype = new window.vcTemplate();
ContactManager.prototype.init = function () {
    /// <summary>
    /// This function inits the the Object <br/>
    /// it does nothing more than adding the clickhandler
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }

        me.showInfo("", "", false);
        me.initClickHandler();
        me.visual.find(".button-toggle-active").trigger("click");
        me.vcVisual.addVisualBaseByName('contact', 'WIDGET_PROJECT_CONTACTS', 'List', window.getCurrentTimestamp(), me.height-100, me.visual.find('#contactList').width(), '', JSON.stringify({
            "loggerid": me.ids.loggerid
        }),  me.deviceType);
        return true;
    } catch (ex) {
        me.writeError('ContactManager.init', ex);
        return false;
    }
};

ContactManager.prototype.loadDetailForms = function () {

    var me = this;
    var type;
    try {                                                                                                                  
        if (me.error) {
            return false;
        }
        //init list entry click handler
        type = me.visual.find('.button-toggle-active').attr("data-type");
        me.visual.find("#contactWrapper").height(me.visual.height() - 100);
        me.vcVisual.setShowFullscreen(false);
        me.vcVisual.setShowHeaderMenu(false);
        me.visual.find("#detailContent").html(me.vcC.getLoadingIcon());
        me.vcVisual.addVisualBaseByName('contact', 'FORM_PROJECT_CONTACTS', 'Forms', window.getCurrentTimestamp(), me.visual.find('#contactForms').height(), 600,  JSON.stringify({ 'type': type, "loggerid": me.ids.loggerid }), '', me.deviceType);

        return true;
    } catch (ex) {
        me.writeError("ContactManager.loadDetailForms", ex);return false;
    }
};

ContactManager.prototype.doEvent = function (event) {
    var me = this;
    try{
    if (event.msg === "UPDATE_CONTACTS") {
        me.vcVisual.addVisualBaseByName('contact', 'WIDGET_PROJECT_CONTACTS', 'List', window.getCurrentTimestamp(), me.visual.find('#contactList').height(), 600, "", JSON.stringify({
            "loggerid": me.ids.loggerid
        }), me.deviceType);
        me.visual.find(".button-toggle-active").trigger("click");
    }
    } catch (ex) {
        me.writeError("ContactManager.loadDetailForms", ex); 
    }
};

ContactManager.prototype.initClickHandler = function () {
    var me = this;
    try {
        if (me.error) {
            return false;
        }

        me.visual.find(".button-toggle").button().off("click").on("click", function () {
            me.visual.find(".button-toggle").removeClass("button-toggle-active");
            $(this).addClass("button-toggle-active");
            me.loadDetailForms();
        });
        return true;
    } catch (ex) {
        me.writeError('ContactManager.initClickHandler', ex);
        return false;
    }
};

ContactManager.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This function  hides/fades out content on error state.
    /// </summary>
    var me = this;
    try {
        if (bError) {
            me.visual.find('.toggle-button, #divContent').hide();
        }
        return true;
    } catch (ex) {
        me.writeError('specificInfoHandling', ex);
        return false;
    }
};

